import type { Container, Sprite } from 'pixi.js';
import type { EnemyPose } from '../enemies';
import { BOSS_SCALE } from '../face-kit';

export function onMaskPoint(
  pose: EnemyPose,
  [ox, oy]: readonly [number, number],
): { x: number; y: number } {
  const { sprite: mask } = pose;
  const dx = ox * BOSS_SCALE * mask.scale.x;
  const dy = oy * BOSS_SCALE * mask.scale.y;
  const cos = Math.cos(mask.rotation);
  const sin = Math.sin(mask.rotation);
  return { x: mask.position.x + dx * cos - dy * sin, y: mask.position.y + dx * sin + dy * cos };
}

export function placeOnMask(
  sprite: Sprite,
  pose: EnemyPose,
  parent: Container,
  at: readonly [number, number],
  fine: number,
): void {
  const { sprite: mask } = pose;
  if (sprite.parent !== parent) {
    parent.addChild(sprite);
  }
  const { x, y } = onMaskPoint(pose, at);
  sprite.visible = true;
  sprite.position.set(x, y);
  sprite.rotation = mask.rotation;
  sprite.scale.set((mask.scale.x * BOSS_SCALE) / fine, (mask.scale.y * BOSS_SCALE) / fine);
}
